import { createSelector, createFeatureSelector } from '@ngrx/store';
import { SessionState } from '@store/session/session.state';

export const selectSessionState = createFeatureSelector<SessionState>('sessionState');

export const selectToken =                  createSelector(selectSessionState, (state: SessionState) => state.token);
export const selectRefreshToken =           createSelector(selectSessionState, (state: SessionState) => state.refreshToken);
export const selectAuthMethods =            createSelector(selectSessionState, (state: SessionState) => state.authMethods);
export const selectTotpRegisterAuth =       createSelector(selectSessionState, (state: SessionState) => state.totpRegisterAuth);
export const selectVerifyMethodError =      createSelector(selectSessionState, (state: SessionState) => state.verifyMethodError);